import { all, put, take } from 'redux-saga/effects';

import { PIPELINE__GET_CONFIGURATION } from 'PipeRouter';
import getConfig from './getConfig';


function* pipeline() {
  while (true) {
    const { data:{ cmd, data }} = yield take(PIPELINE__GET_CONFIGURATION);

    yield put({ type: cmd, data });
  }
}

export default function*() {
  yield all([
    pipeline(),
    getConfig()
  ]);
}
